import { updateFlagsForUser } from "#webapp/src/mutations";
import { IReduxState } from "#webapp/src/state/reducers/root.reducer";
import { FlagNamespaces, UserFlags, isFlagSet } from "#webapp/src/util/flags.util";
import Button from "@material-ui/core/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
import { styles } from "../TutorialBox.styles";
import { IContainer, IProps, IState } from "./TutorialTeamHealthTypes";

//////////////////
// COMPONENT
//////////////////
class TutorialTeamHealthCmpt extends React.Component<IProps, IState> {
  private removalTimeout: ReturnType<typeof setTimeout>;

  constructor(props: IProps) {
    super(props);

    this.state = {
      isPendingRemoval: false,
    };
  }

  public componentWillUnmount() {
    this.clearTimeouts();
  }

  private onSetFlagSuccess = () => {
    this.setState({ isPendingRemoval: false });
  };

  private onSetFlagFailure = () => {
    this.setState({ isPendingRemoval: false });
  };

  private setFlag = () => {
    updateFlagsForUser(
      this.props.relay.environment,
      {
        flagNamespace: FlagNamespaces.ChromeExtension,
        flagNames: [UserFlags.Onboarding.TeamHealth.name],
        enable: true,
      },
      this.onSetFlagSuccess,
      this.onSetFlagFailure,
    );
  };

  // ~-~-~-~-~-~-~-
  // Removal Animations
  // ~-~-~-~-~-~-~-
  private clearTimeouts = () => {
    clearTimeout(this.removalTimeout);
  };

  private delayedRemove = () => {
    this.removalTimeout = setTimeout(() => this.setFlag(), 500);
  };

  private startRemoval = () => {
    this.setState({ isPendingRemoval: true }, () => this.delayedRemove());
  };

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  public render() {
    const { flags, classes } = this.props;
    const { isPendingRemoval } = this.state;

    const showTip = !isFlagSet(UserFlags.Onboarding.TeamHealth.name, flags);

    if (!showTip) {
      return <span />;
    }

    return (
      <div className={classNames(classes.container, { [classes.hidden]: isPendingRemoval })}>
        <div className="cw-heading-base cw-mb-2 cw-text-onEmphasis">Your team at a glance</div>
        <div className={classes.body}>
          See how much Focus Time your teammates have in order to better predict your team's
          bandwidth.
        </div>
        <Button className={classes.button} onClick={this.startRemoval} variant="outlined">
          Got it
        </Button>
      </div>
    );
  }
}

//////////////////
// WITH STYLES
//////////////////
export const TutorialTeamHealthStyled = withStyles(styles)(TutorialTeamHealthCmpt);

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

const TutorialTeamHealthRedux = connect(mapStateToProps, {})(TutorialTeamHealthStyled);

//////////////////
// RELAY
//////////////////
import { fragments } from "./TutorialTeamHealth.gql";
export const TutorialTeamHealth = createFragmentContainer<IContainer>(
  TutorialTeamHealthRedux,
  fragments,
);
